import { Component, Input, OnInit } from '@angular/core';
import { CarModel } from "../../../../models/car/car.model";
import { faCar, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { Yii } from "../../../../interfaces/Yii";

interface ICarTitle {
  name: string;
  duration: string;
}

class WordingClass {
  public readonly rentalDuration: string = Yii.t('wui-shared-js', 'Durée de la location');
  public readonly days: string = Yii.t('wui-shared-js', 'jours');
}

@Component({
  selector: 'car-title',
  template: `
    <fa-icon [icon]="iconCar"></fa-icon>
    <div class="name">
        <strong>{{carTitle.name}}</strong>
        <small><strong>{{wording.rentalDuration}} {{carTitle.duration}} {{wording.days}}</strong></small>
    </div>
  `,
  styles: [`
    :host {
      display: flex;
      gap: 0.2rem;
    }
    .name {
      display: flex;
      flex-direction: column;
    }
  `]
})
export class CarTitleComponent implements OnInit {
  @Input()
  public booking: CarModel;

  public iconCar: IconDefinition = faCar;
  public carTitle: ICarTitle;
  public readonly wording: WordingClass = new WordingClass();

  constructor() { }

  public ngOnInit(): void {
    this.initCarTitle();
  }

  private initCarTitle(): void {
    this.carTitle = {
      name: this.booking.booking.getVehicleByXRef(this.booking.booking.vehicleRental.vehicleArray[0].xRef).name,
      duration: this.booking.booking.vehicleRental.duration.toString(),
    };
  }


}
